// libs
import random from 'lodash/random';

import { generateShortId } from '@lyearn/core/utils/id';
// types
import { DatabaseMetadataFieldType, SelectFieldOptionsType } from '@/types/schema';

const OPTION_COLORS = ['#fef3c7', '#ccf5de', '#dbeafe', '#f2f2f2', '#fee2e2'];

export const getRandomOptionColor = () => OPTION_COLORS[random(OPTION_COLORS.length - 1)];

interface GetNewSelectFieldOptionParams {
  value: string;
  color?: string;
}

export const getNewSelectFieldOption = (params: GetNewSelectFieldOptionParams) => {
  const { value, color = getRandomOptionColor() } = params;

  return {
    value,
    color,
    optionId: generateShortId(),
  };
};

interface AddSelectOptionToMetadataField {
  fieldId: string;
  fields: DatabaseMetadataFieldType[];
  option: SelectFieldOptionsType;
}

export const addSelectOptionToMetadataField = (params: AddSelectOptionToMetadataField) => {
  const { fieldId, fields, option } = params;

  return fields.map((field) => {
    if (field.fieldId === fieldId) {
      return { ...field, options: [...(field.options || []), option] };
    }
    return field;
  });
};
